import {
  ComponentProps, ComponentType, PropsWithChildren, ReactNode,
} from 'react';
import styled from 'styled-components';
import { Flex } from '../Flex';

// base components
export const InfoContainerBase = styled.div`${({ theme }) => `
    border-radius: ${theme.borderRadius[2]};
    color: ${theme.colours.neutral[2]};
    font-size: ${theme.fontSize[2]};
    width:100%;
`}`;

export const InfoIconBase = styled.i`${({ theme }) => `
    font-size: ${theme.fontSize[6]};
`}`;

export const InfoIconContainerBase = styled.div`${({ theme }) => `
    border-top-left-radius: ${theme.borderRadius[2]};
    border-bottom-left-radius: ${theme.borderRadius[2]};
`}`;

// default components
export const DefaultInfoContainer = styled(InfoContainerBase)`${({ theme }) => `
    background: ${theme.colours.info[2]};
`}`;

export const DefaultInfoIconContainer = styled(InfoIconContainerBase)`${({ theme }) => `
    background: ${theme.colours.info[1]};
`}`;

export const DefaultInfoIcon = styled(InfoIconBase).attrs(() => ({
  className: 'mi-circle-information',
}))`${({ theme }) => `
    color: ${theme.colours.neutral[10]};
`}`;

// other components
const IconContainerFlex = styled(Flex)`
    height:100%;
    width:40px;
    align-items:center;
    justify-content:center;
`;

const TextContainer = styled.div`${({ theme }) => `
    padding: ${theme.padding[4]};
    padding-top: ${theme.padding[2]};
    padding-bottom: ${theme.padding[2]};
    width:100%;
`}`;

export type InfoProps = PropsWithChildren & {
  Container?: ComponentType<ComponentProps<'div'>>
  icon?: ReactNode
  IconContainer?: ComponentType<ComponentProps<'div'>>
}

export function Info({
  children,
  Container = DefaultInfoContainer,
  icon = <DefaultInfoIcon />,
  IconContainer = DefaultInfoIconContainer,
} : InfoProps) {
  return (
    <Container>
      <Flex>
        <IconContainer>
          <IconContainerFlex>
            {icon}
          </IconContainerFlex>
        </IconContainer>
        <TextContainer>
          {children}
        </TextContainer>
      </Flex>
    </Container>
  );
}
